module.exports = __webpack_public_path__ + "static/media/logo_alert-as.93b64edc.png";